import React from "react";
import PageHero from "@/components/PageHero";
import Section from "@/components/Section";
import useSeo from "@/hooks/useSeo";

export default function Terms() {
  useSeo("terms", {
    title: "Terms of Service — Quantum Results",
    description:
      "Terms governing use of quantumresults.com and the experiences we offer.",
  });
  return (
    <div data-testid="page-terms">
      <PageHero
        eyebrow="Legal"
        title="Terms of Service"
        lede="By using quantumresults.com, you agree to these terms. Please read them carefully."
        testId="terms-hero"
      />
      <Section testId="terms-body">
        <p><strong>Effective date:</strong> {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
        <h3 className="font-serif text-[22px] text-brand-ink mt-8">The site and its content</h3>
        <p>This website and the experiences offered here are provided by Quantum Results LLC ("Quantum Results," "we," "us"). All content is © Quantum Results LLC unless otherwise noted, and may not be reproduced or redistributed without written permission.</p>
        <h3 className="font-serif text-[22px] text-brand-ink mt-8">Nature of the material</h3>
        <p>The material shared here is intended for reflection, education, and general guidance. It is not a substitute for professional medical, mental-health, legal, or financial advice.</p>
        <h3 className="font-serif text-[22px] text-brand-ink mt-8">Third-party links</h3>
        <p>We link to third-party sites and services (for example, Calendly and FourLevelsExperience.com) for your convenience. We're not responsible for their content or practices.</p>
        <h3 className="font-serif text-[22px] text-brand-ink mt-8">Limitation of liability</h3>
        <p>To the fullest extent permitted by law, Quantum Results LLC is not liable for any indirect, incidental, special, or consequential damages arising from your use of this site.</p>
        <h3 className="font-serif text-[22px] text-brand-ink mt-8">Changes</h3>
        <p>We may update these terms occasionally. Continued use of the site after changes take effect indicates acceptance.</p>
        <h3 className="font-serif text-[22px] text-brand-ink mt-8">Contact</h3>
        <p>Write to <a className="link-quiet" href="mailto:info@quantumresults.com">info@quantumresults.com</a> with any questions.</p>
      </Section>
    </div>
  );
}
